package com.mshopsas.enterprise.aiw.scan.network.response

import com.mshopsas.enterprise.aiw.scan.data.basket.details.ProductDetail
import kotlinx.serialization.Serializable

@Serializable
data class ProductRelatedResponse(
    val productList : List<ProductDetail>?
)